<script lang="ts" setup>
import { staticPromocodes } from '~/utils/staticPromocodes';

const { isMobile } = useLayout();
const { openToaster } = useLayoutStore();
const authStore = useAuthStore();
const { openLogin } = useAuth();
const route = useRoute();

const isRulesModalVisible = ref(false);
const promocode = ref('');

watchEffect(() => {
  if (route.query.promocode) {
    promocode.value = route.query.promocode as string;
  }
});

const isPromocodeButtonActive = computed(() => {
  return staticPromocodes.includes(promocode.value);
});

const staticRulesText = [
  'Termos e Condições – Promocodes Aposta Tudo',
  '',
  'Os promocodes são benefícios oferecidos pela Aposta Tudo de forma pontual e seguem as regras abaixo. Ao utilizá-los, o jogador concorda com estes termos:',
  '',
  '1. Uso e Elegibilidade',
  '',
  'Cada promocode é limitado a um número máximo de usos e pode ser resgatado apenas uma vez por jogador.',
  '',
  'Cada promocode é limitado a um número máximo de usos, definido internamente pela Aposta Tudo.',
  '',
  'Algumas campanhas podem ser restritas a novos jogadores ou a contas ativas, conforme informado na comunicação oficial.',
  '',
  '2. Benefícios',
  '',
  'Podem incluir saldo real, giros grátis ou giros em minigames.',
  '',
  'Caso haja valor mínimo de depósito ou aposta, será informado no momento da divulgação.',
  '',
  'Não há exigência de rollover, salvo se comunicado de forma expressa.',
  '',
  '3. Segurança e Controle',
  '',
  'É proibido o uso de múltiplas contas ou qualquer tentativa de fraude.',
  '',
  'Em caso de uso indevido, a Aposta Tudo poderá cancelar o benefício e bloquear a conta.',
  '',
  '4. Comunicação',
  '',
  'Promocodes são divulgados apenas por canais oficiais (lives, Telegram, Instagram ou outros canais da Aposta Tudo).',
  '',
  '5. Condicionalidade',
  '',
  'O recebimento de promocodes depende do cumprimento das regras de elegibilidade.',
  '',
  'A Aposta Tudo não é obrigada a disponibilizar promocodes para todos os usuários.',
];

function handleRulesClick() {
  isRulesModalVisible.value = true;
}

function applyPromocode() {
  if (!authStore.isAuthenticated) {
    openLogin();

    return;
  }
  if (staticPromocodes.includes(promocode.value) && authStore.isAuthenticated) {
    if (window && window._smartico) {
      window._smartico.action(promocode.value);
      promocode.value = '';
    } else {
      console.warn('Smartico object not found on window.');
      openToaster({
        message: 'Serviço indisponível no momento. Promocode não aplicado.',
        type: 'warning',
      });
    }
  } else {
    openToaster({
      message: 'Promocode não aplicado.',
      type: 'error',
    });
  }
}
</script>

<template>
  <SmarticoBaseHeader
    class="select-none mt-0"
    :is-hidden-filters="true"
    :reloading-page="false"
  >
    <div
      v-if="isMobile"
      class="flex flex-col items-start justify-center"
    >
      <span class="w-[82px] text-white text-base font-bold leading-[21px]">
        Bônus
      </span>

      <span class="text-[#B4B7BD] text-[11px] font-medium mt-1">
        Encontre ou digite seu promocode
      </span>
    </div>
    <div
      v-else
      class="flex items-center justify-start"
    >
      <span class="text-white text-[15px] font-semibold leading-4">
        Promocode
      </span>
    </div>
  </SmarticoBaseHeader>

  <div v-if="isMobile">
    <div
      class="flex flex-col items-start gap-2.5 self-stretch border backdrop-blur-[10px] p-5 rounded-[10px] border-solid border-[#1B1E2F] mt-4 mb-4"
    >
      <span class="text-[#B4B7BD] text-[11px] font-medium leading-[100%]"
        >Código promocional</span
      >
      <input
        v-model="promocode"
        class="flex h-[34px] items-center gap-2.5 self-stretch bg-[#030D26] p-5 rounded-[4px] border-2 border-solid border-[#161D32] text-[#B0BED9] text-[10px] font-bold leading-[14px]"
        placeholder="Digite seu Promocode"
        type="text"
        @keyup.enter="applyPromocode"
      />
      <button
        class="flex h-[34px] justify-center items-center gap-[7px] self-stretch p-2.5 rounded-[4px] text-center text-xs font-extrabold leading-4"
        :class="
          isPromocodeButtonActive
            ? '[background:var(--ATNB---ORANGE,radial-gradient(168.3%_138%_at_36.76%_-16.67%,#FF704A_0%,#FF3400_100%))] border-[#FC9984] text-white'
            : '[background:#303747] text-[#B7B7B7]'
        "
        :disabled="!isPromocodeButtonActive"
        @click="applyPromocode"
        >RESGATAR CUPOM</button
      >
      <button
        class="flex justify-center items-center gap-[5px] self-stretch [background:rgba(255,255,255,0.05)] px-2.5 py-[5px] rounded-[1000px]"
        @click="handleRulesClick"
      >
        <NuxtIcon
          class="text-[14px] text-[rgba(255,255,255,0.50)]"
          name="mission/info"
        />
        <span
          class="text-[rgba(255,255,255,0.50)] text-xs font-medium leading-3"
          >Regras de uso</span
        >
      </button>
    </div>
  </div>

  <div
    v-else
    class="mt-9 mb-4"
  >
    <div
      class="flex flex-wrap items-center justify-between gap-2.5 self-stretch border backdrop-blur-[10px] p-5 rounded-[10px] border-solid border-[#1B1E2F] mt-4 mb-4 text-white"
    >
      <div class="flex flex-col items-start justify-start gap-2.5 self-stretch">
        <span class="text-white text-[22px] font-bold leading-[120%]"
          >Ative o seu código promocional</span
        >
        <div class="flex items-center gap-2.5 self-stretch justify-center">
          <span class="text-[#B4B7BD] text-[11px] font-medium leading-[130%]"
            >Alguns bônus exigem regras para serem ativados:</span
          >
          <button
            class="flex justify-center items-center gap-[5px] self-stretch [background:rgba(255,255,255,0.05)] px-[10px] py-[5px] rounded-[1000px]"
            @click="handleRulesClick"
          >
            <NuxtIcon
              class="text-[14px] text-[rgba(255,255,255,0.50)]"
              name="mission/info"
            />
            <span
              class="text-[rgba(255,255,255,0.50)] text-xs font-medium leading-3"
              >Regras de uso</span
            >
          </button>
        </div>
      </div>
      <div class="flex flex-col items-start justify-start gap-2.5 self-stretch">
        <span class="text-[#B4B7BD] text-[11px] font-medium"
          >Código promocional</span
        >
        <div class="flex items-start gap-2.5 self-stretch">
          <input
            v-model="promocode"
            class="flex w-[360px] h-[34px] items-center gap-2.5 self-stretch bg-[#030D26] px-[20px] py-[10px] rounded-[4px] border-2 border-solid border-[#161D32] text-[#B0BED9] text-[10px] font-bold leading-[14px]"
            placeholder="Digite seu Promocode"
            type="text"
            @keyup.enter="applyPromocode"
          />
          <button
            class="flex h-[34px] justify-center items-center gap-[7px] self-stretch py-[9px] px-[22px] rounded-[4px] text-center text-xs font-extrabold leading-4"
            :class="
              isPromocodeButtonActive
                ? '[background:var(--ATNB---ORANGE,radial-gradient(168.3%_138%_at_36.76%_-16.67%,#FF704A_0%,#FF3400_100%))] border-[#FC9984] text-white'
                : '[background:#303747] text-[#B7B7B7]'
            "
            :disabled="!isPromocodeButtonActive"
            @click="applyPromocode"
            >RESGATAR CUPOM</button
          >
        </div>
      </div>
    </div>
  </div>

  <h1 class="text-white/60 text-center mb-8 px-4 leading-tight">
    Promocode: resgate bônus e cupons Apostatudo
  </h1>

  <BaseModalMissionModal v-model="isRulesModalVisible">
    <template #header>
      <NuxtIcon
        class="text-xl text-white"
        name="mission/info"
      />
      <p class="text-lg font-bold text-white">Regras de uso</p>
    </template>
    <div v-if="staticRulesText">
      <p
        v-for="(line, index) in staticRulesText"
        :key="index"
        class="mb-2 text-white/50 font-normal text-[13px] whitespace-pre-wrap"
      >
        {{ line }}
      </p>
    </div>
  </BaseModalMissionModal>
</template>
